import { actions as bundleActions } from "containers/Bundles/Bundles.reducer";

export const setActiveBundle = (dispatch, iri) =>
    dispatch({
        type: bundleActions.STORE_ACTIVE_BUNDLE,
        iri,
    });
